<template>
    <div @click="check" class="filter">
        <span :aria-checked="isSentimentChecked" :class="['filter__label', `filter__label--${value}`]"></span>
        <span :style="{textDecoration: isSentimentChecked ? 'line-through' : 'none' }" class="filter__label-text add-cursor"><slot></slot></span>
    </div>
</template>

<script>
	export default {
		name: "TopicCloudCustomFilter",
		model: {
			prop: 'checked',
			event: 'change'
		},

        props:['checked', 'value'],

		computed: {
			isSentimentChecked() {
                return !this.checked.includes(this.value);
			}
		},

		methods: {
			check() {
				let payload = this.checked.includes(this.value) ?
					this.checked.filter(value => value !== this.value):
					[...this.checked, this.value];
				this.$emit("change", payload);
			}
		},
    }
</script>

<style scoped>
    .filter {
        display: inline-block;
        box-sizing: border-box;
        position:relative;
        width: 95px;
        height: 15px;
    }

    .filter:not(:last-child){
        margin-right: 10px;
    }

    .filter__label {
        display:inline-block;
        width: 42px;
        height: 12px;
        background-color: #777777;
        cursor: pointer;
        user-select: none;
        position: absolute;
        top: 50%;
        left: 0;
        transform: translate(0, -50%);
    }

    .filter__check {
        display: none;
    }

    .filter__check:checked ~ span{
        text-decoration: line-through;
    }

    span.filter__label-text{
        position:absolute;
        left: 45%;
        top: 50%;
        transform: translate(0, -50%);
        margin-left: 3px;
        font-size: 12px;
        font-weight: 300;
        user-select: none;
    }

    .filter__label--positive{
        background-color:#1AB177;
    }
    .filter__label--negative{
        background-color: #EB2929;
    }
    .filter__label--neutral{
        background-color:#EAC82A;
    }
    .filter__label--interest{
        background-color:#1F65C5;
    }
</style>
